export default "__VITE_ASSET__3df0WzQ3__"